import React from "react";
import ReactDOM from "react-dom/client";
import "@/styles/dashboard.css";
import "@/styles/additions.css";
import "@/styles/branding.css";
import "@/styles/login.css";
import "@/styles/admin.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
